import { categories } from '../data/products';
import { Link } from 'react-router-dom';

const TILTS = ['-rotate-2', 'rotate-1', '-rotate-1', 'rotate-2'];

const CategoryCard = ({ category, index }) => (
  <Link
    to={`/category/${category.slug}`}
    className={`group relative block ${
      TILTS[index % TILTS.length]
    } hover:rotate-0 hover:-translate-y-1
      transition-transform duration-300 ease-out
      bg-white rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)]
      hover:shadow-[0_14px_28px_rgba(27,27,31,0.16)]
      text-right w-full`}
  >
    {/* شريط لاصق أعلى البطاقة */}
    <span
      aria-hidden="true"
      className="absolute -top-2.5 left-1/2 -translate-x-1/2 -rotate-3 w-14 h-5
      bg-[#F2B705]/70 rounded-sm shadow-sm"
    />

    <div className="p-2.5">
      <div className="aspect-square overflow-hidden rounded-xl">
        <img
          src={category.image}
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="pt-3 pb-1 flex flex-col items-center text-center gap-1.5">
        <h3
          className="text-[15px] font-bold text-[#1B1B1F] leading-snug"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          {category.name}
        </h3>

        <span
          className="inline-block bg-[#1B1B1F] text-white text-[11px] px-2.5 py-0.5 rounded-full"
          style={{ fontFamily: "'Cairo', sans-serif" }}
        >
          {category.itemCount}
        </span>
      </div>
    </div>
  </Link>
);

const CategoryGrid = () => {
  return (
    <section className="py-16 bg-[#F6F5F2]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2
            className="text-3xl md:text-4xl font-extrabold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            تسوق حسب الفئة
          </h2>

          <svg
            className="mx-auto mt-3"
            width="140"
            height="10"
            viewBox="0 0 140 10"
            fill="none"
          >
            <path
              d="M2 7c15-8 25 6 40-2s25 6 40-2 25 6 38-1"
              stroke="#F2B705"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {categories.map((category, index) => (
            <CategoryCard
              key={category.id}
              category={category}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
